import AddIcon from '@mui/icons-material/Add';
import { Stack, Typography } from '@mui/material';
import { Button } from 'components/Button';
import { useTreatmentConsultation } from 'context';
import { TreatmentConsultationFilter } from '../TreatmentConsultationFilter';

export const TreatmentConsultationHeader: React.FC = () => {
  const {
    hasSomeDoc,
    saveTreatmentConsultationModal,
    currentTreatmentConsultation,
  } = useTreatmentConsultation();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      {hasSomeDoc ? (
        <Typography color="#4B4B4B" fontWeight={500} fontSize={16}>
          Consultas
        </Typography>
      ) : null}

      <Stack direction="row" spacing={1} flex={1} justifyContent="flex-end">
        {!currentTreatmentConsultation ? (
          <Button
            startIcon={<AddIcon />}
            onClick={saveTreatmentConsultationModal.onOpen}
          >
            NOVA CONSULTA
          </Button>
        ) : null}

        {hasSomeDoc ? <TreatmentConsultationFilter /> : null}
      </Stack>
    </Stack>
  );
};
